var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-perfect-scrollbar',{staticClass:"Scrollbar",style:(_vm.style),attrs:{"settings":_vm.settings}},[_c('div',{staticClass:"ScrollbarInner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }